// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"ce61242c","244":"d9769437","380":"1c1d22c1","408":"f66cfa19","555":"35cd5a9d","607":"223040bf","656":"d9619323","756":"dce0cde7","788":"e869c564","808":"83bc80f9","824":"240f822b","856":"f94964a3","864":"ce5dcf4f","884":"ca556954","936":"6a7081f3","996":"ba1f20bd"}[chunkId] + ".chunk.js";
};